import FilterOutlineIcon from '@eduzz/houston-icons/FilterOutline';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { Form as FormikForm, Field, useFormikContext } from 'formik';
import moment from 'moment';
import React from 'react';
import { isInclusivelyBeforeDay } from 'react-dates';
import { useObservable } from 'react-use-observable';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import { ECustomerSearchTypes } from 'v2/interfaces/reports/partnerCommissions';
import { initialFilter, partnerCommissionsService } from 'v2/services/reports/partnerCommissions';

import type { IPartnerCommissionFilter } from 'v2/interfaces/reports/partnerCommissions';

import { useStyles } from './styles';

import type { Moment } from 'moment';

const customerTypes = [
  { label: 'E-mail', value: ECustomerSearchTypes.EMAIL },
  { label: 'Nome', value: ECustomerSearchTypes.NAME },
];

export const Form = () => {
  const classes = useStyles();

  const { values, setFieldValue, isValid, isSubmitting, resetForm, dirty } = useFormikContext<IPartnerCommissionFilter>();

  const [isLoading] = useObservable(() => partnerCommissionsService.isLoading(), []);

  const isOutsideRange = (day: Moment) => !isInclusivelyBeforeDay(day, moment());

  const onChangeCustomerType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue('commissioned', '');
    setFieldValue('commissioned_type', e.target.value);
  };

  const handleClean = () => {
    resetForm({ values: initialFilter });
  };

  const customerLabel = values.commissioned_type === ECustomerSearchTypes.NAME ? 'Nome' : 'E-mail';

  const customerPlaceholder = values.commissioned_type === ECustomerSearchTypes.NAME ? 'Insira o nome' : 'Insira o e-mail';

  const isFilterDisabled = !isValid || isSubmitting || isLoading;
  const isCleanDisabled = !dirty || isSubmitting || isLoading;

  return (
    <FormikForm>
      <div id='commissions-paid-to-partners' className={classes.root}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <Field label='Período' id='date' name='date' component={DateRangePickerFormField} isPresetLonger isOutsideRange={isOutsideRange} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container>
              <Grid item xs={4}>
                <Field
                  id='commissioned_type'
                  name='commissioned_type'
                  label='Parceiro'
                  inputProps={{
                    className: classes.leftInput,
                  }}
                  options={customerTypes}
                  onChange={onChangeCustomerType}
                  component={SelectFormField}
                  fullWidth
                />
              </Grid>
              <Grid item xs={8}>
                <Field
                  id='commissioned'
                  name='commissioned'
                  label={customerLabel}
                  placeholder={customerPlaceholder}
                  inputProps={{
                    className: classes.rightInput,
                  }}
                  component={TextFormField}
                  fullWidth
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <div className={classes.buttons}>
          <Button id='clean-filter-button' onClick={handleClean} variant='text' disabled={isCleanDisabled} fullWidth>
            Limpar
          </Button>
          <Button
            id='filter-button'
            color='primary'
            variant='contained'
            disabled={isFilterDisabled}
            type='submit'
            fullWidth
            startIcon={
              isSubmitting || isLoading ? <CircularProgress size={20} color='inherit' /> : <FilterOutlineIcon className={classes.filterIcon} />
            }
          >
            Filtrar
          </Button>
        </div>
      </div>
    </FormikForm>
  );
};
